import React from 'react';
export function Advocates() {
  return <section id="advocates" className="py-32 lg:py-40 bg-cream relative" data-id="element-49">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.02] bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] pointer-events-none" data-id="element-50" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-51">
        <div className="text-center mb-24" data-id="element-52">
          <div className="flex items-center justify-center space-x-4 mb-6" data-id="element-53">
            <div className="h-px w-12 bg-[#D4AF37]" data-id="element-54"></div>
            <h2 className="text-xs font-cormorant font-bold tracking-[0.3em] text-[#D4AF37] uppercase" data-id="element-55">
              Leadership
            </h2>
            <div className="h-px w-12 bg-[#D4AF37]" data-id="element-56"></div>
          </div>
          <h3 className="font-playfair text-5xl md:text-6xl font-bold text-navy tracking-tight" data-id="element-57">
            Our Advocates
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 lg:gap-24" data-id="element-58">
          {/* Sheila Wanja Konji */}
          <div className="group" data-id="element-59">
            <div className="relative h-[500px] mb-10 p-3 border border-[#D4AF37]/30 bg-cream-dark transition-all duration-700 hover:border-[#D4AF37]" data-id="element-60">
              <div className="relative w-full h-full overflow-hidden" data-id="element-61">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800&h=1000" alt="Sheila Wanja Konji" className="w-full h-full object-cover object-center grayscale group-hover:grayscale-0 transition-all duration-1000 transform group-hover:scale-105" data-id="element-62" />
                <div className="absolute inset-0 bg-navy/20 mix-blend-multiply opacity-0 group-hover:opacity-100 transition-opacity duration-1000" data-id="element-63" />

                {/* Gold accent overlay on hover */}
                <div className="absolute inset-0 border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-700 m-4" data-id="element-64" />
              </div>
            </div>

            <div className="text-center lg:text-left" data-id="element-65">
              <h4 className="font-playfair text-4xl font-bold text-navy mb-3 tracking-tight" data-id="element-66">
                Sheila Wanja Konji
              </h4>
              <p className="text-xs font-bold tracking-[0.2em] text-[#D4AF37] uppercase mb-8" data-id="element-67">
                Managing Partner
              </p>

              <div className="mb-8 pb-8 border-b border-[#D4AF37]/20 relative" data-id="element-68">
                <div className="absolute bottom-0 left-1/2 lg:left-0 -translate-x-1/2 lg:translate-x-0 w-12 h-px bg-[#D4AF37]" data-id="element-69" />
                <p className="font-cormorant text-lg text-gray-600 italic leading-relaxed" data-id="element-70">
                  Advocate of the High Court of Kenya &bull; Commissioner for
                  Oaths &bull; Notary Public &bull; Certified Data Privacy
                  Professional &bull; Certified Mediator &bull; Member, Law
                  Society of Kenya &bull; Member, Data Governance Society
                </p>
              </div>

              <div className="space-y-4 text-gray-600 font-light leading-relaxed" data-id="element-71">
                <p data-id="element-72">
                  Sheila brings nearly a decade of progressive Legal and
                  Compliance experience spanning from private legal practice,
                  financial services, corporate governance, and regulatory
                  compliance. She leads the firm's dual practice in Legal
                  Services and Compliance Consulting.
                </p>
                <p data-id="element-73">
                  Her career highlights include six years at Equity Group
                  Holdings PLC and serving as Group Contracts and Compliance
                  Specialist at Nathan Digital. She has a proven track record in
                  enterprise-wide compliance programs, corporate governance, and
                  data protection implementation.
                </p>
              </div>
            </div>
          </div>

          {/* Mellody Mwende Mwavichi */}
          <div className="group lg:mt-24" data-id="element-74">
            <div className="relative h-[500px] mb-10 p-3 border border-[#D4AF37]/30 bg-cream-dark transition-all duration-700 hover:border-[#D4AF37]" data-id="element-75">
              <div className="relative w-full h-full overflow-hidden" data-id="element-76">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=800&h=1000" alt="Mellody Mwende Mwavichi" className="w-full h-full object-cover object-center grayscale group-hover:grayscale-0 transition-all duration-1000 transform group-hover:scale-105" data-id="element-77" />
                <div className="absolute inset-0 bg-navy/20 mix-blend-multiply opacity-0 group-hover:opacity-100 transition-opacity duration-1000" data-id="element-78" />

                {/* Gold accent overlay on hover */}
                <div className="absolute inset-0 border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-700 m-4" data-id="element-79" />
              </div>
            </div>

            <div className="text-center lg:text-left" data-id="element-80">
              <h4 className="font-playfair text-4xl font-bold text-navy mb-3 tracking-tight" data-id="element-81">
                Mellody Mwende Mwavichi
              </h4>
              <p className="text-xs font-bold tracking-[0.2em] text-[#D4AF37] uppercase mb-8" data-id="element-82">
                Partner
              </p>

              <div className="mb-8 pb-8 border-b border-[#D4AF37]/20 relative" data-id="element-83">
                <div className="absolute bottom-0 left-1/2 lg:left-0 -translate-x-1/2 lg:translate-x-0 w-12 h-px bg-[#D4AF37]" data-id="element-84" />
                <p className="font-cormorant text-lg text-gray-600 italic leading-relaxed" data-id="element-85">
                  Advocate of the High Court of Kenya &bull; Commissioner for
                  Oaths &bull; Member, Law Society of Kenya
                </p>
              </div>

              <div className="space-y-4 text-gray-600 font-light leading-relaxed" data-id="element-86">
                <p data-id="element-87">
                  Mellody holds a Master of Laws degree with dual concentrations
                  in Public International Law and Corporate Finance from the
                  University of Nairobi. She is currently pursuing a PhD in Law
                  degree with a focus on Tax Law, Governance, and Sustainability
                  in Kenya.
                </p>
                <p data-id="element-88">
                  With nearly a decade of experience, Mellody has practiced with
                  leading law firms including Waweru Gatonye & Co. Advocates and
                  Munyao Muthama & Kashindi Advocates. Her expertise includes
                  civil litigation, legal advisory, corporate governance, and
                  intellectual property rights.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}